// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3ZxwRePeQ40fENO7NA42Qp","modalTitle":"_2h4RwOAs-944Xrj2gSmHof","modalContent":"_1jUpd6FHiriyFyCk2Pu1mW","modalFooter":"_2T1O29nH0ejBAHWcc4pjJT"};